import angular from 'angular';
import TimerRegistrationService from '@/shared/services/TimerRegistrationService';
import RecentRelationsService from '@/shared/services/RecentRelationsService';
import eventBus from 'pubsub-js';

angular.module('cxRegistrations').directive('timerRegistrationButton', [
  function() {
    return {
      restrict: 'E',
      template: `
      <p class="timer-reg-button"
         uib-popover-template="'timerRegistrationInfo.html'"
         popover-enable="!!tmr.registration"
         popover-placement="bottom auto"
         popover-is-open="tmr.showPopover"
         popover-trigger="{'outsideClick':'outsideClick', 'mouseenter':'none'}">
       <a ng-click="tmr.start()" ng-show="!tmr.isRunning" class="start-btn">
         <i class="fa fa-clock-o"></i>
       </a>
       <a ng-show="!tmr.isRunning && tmr.isPaused" class="pause-btn" ng-click="tmr.restart()" title="{{('Restart registration'|translate)}}">
        <i class="fa fa-pause-circle"></i>
       </a>
       <a ng-show="tmr.isRunning" class="stop-btn">
        <i class="fa fa-clock-o fa-spin"></i>
       </a>
       <create-timer-registration-modal on-save="tmr.createRegistration" on-close="tmr.closeModal" initial-value="tmr.registration" ng-if="tmr.showModal" show="tmr.showModal"></create-timer-registration-modal>
       <script type="text/ng-template" id="timerRegistrationInfo.html">
        <div class="timer-reg-popover" ng-if="tmr.registration">
          <div class="tbl">
            <div class="tr">
              <div class="td"><label data-translate="Relation"></label></div>
              <div class="td">
                <a ng-click="$event.stopPropagation()"
                  ui-sref="relations.detail({relId:tmr.registration.relation.id})">
                  <cx-relation-icon type="tmr.registration.relation.type" crm="tmr.registration.relation.crm" active="tmr.registration.relation.isActive" iclass="fa-fw"></cx-relation-icon>
                </a>
              </div>
              <div class="td">
                <span>{{tmr.registration.relation | relationName}}</span>
              </div>
            </div>
            <div class="tr" assignments-enabled>
              <div class="td"><label data-translate="Assignment"></label></div>
              <div class="td"></div>
              <div class="td">
                <span>{{tmr.registration.invoiceStream | invoiceStreamName}}</span>
              </div>
            </div>
            <div class="tr" ng-if="tmr.registration.plannedTaskId">
              <div class="td"><label data-translate="Task"></label></div>
              <div class="td">
                <a ui-sref="taskflow.taskboard({plannedTaskId:tmr.registration.plannedTaskId})" ui-sref-opts="{ reload: true }" title="{{('OpenInTaskboard'|translate)}}">
                  <i class="fa fa-external-link"></i>
                </a>
              </div>
              <div class="td">
                {{tmr.registration|regTaskName}}
              </div>
            </div>
            <div class="tr">
              <div class="td"><label data-translate="Resource"></label></div>
              <div class="td"></div>
              <div class="td">
                <span>{{tmr.registration.resource | resourceName}}</span>
              </div>
            </div>
            <div class="tr">
            <div class="td"><label data-translate="StartTime"></label></div>
            <div class="td"></div>
            <div class="td">
              <span>{{tmr.registration.fromMinutes.minuteToTime()}}</span>
            </div>
          </div>
            <div class="tr">
              <div class="td"><label data-translate="Duration"></label></div>
              <div class="td">
                <a ng-click="tmr.stop()" ng-show="tmr.isRunning" class="stop-btn margin5L">
                  <i class='fa fa-stop-circle'></i>
                </a>
                <a ng-click="tmr.stop(true)" ng-show="tmr.isRunning" class="pause-btn margin5L">
                  <i class='fa fa-pause-circle'></i>
                </a>
              </div>
              <div class="td">
                <span>{{tmr.registration.durationMinutes.minuteToTime()}}</span>
              </div>
            </div>
          </div>
        </div>
       </script>
      </p>`,

      replace: true,
      controllerAs: 'tmr',
      controller: [
        '$scope',
        '$timeout',
        'flySvc',
        '$filter',
        'regDialogsSvc',
        'recentRelationsSvc',
        'checkSecurity',
        timerButtonCtrl,
      ],
    };
  },
]);

const timerButtonCtrl = function(
  $scope,
  $timeout,
  flySvc,
  $filter,
  regDialogsSvc,
  recentRelationsSvc,
  checkSecurity,
) {
  const tmr = this;
  tmr.isRunning = false;
  tmr.registration = null;
  tmr.showModal = false;
  tmr.showPopover = false;

  tmr.refreshRunningRegistration = () => {
    $timeout(() => {
      tmr.registration = TimerRegistrationService.getRunningRegistration();
      tmr.isRunning = TimerRegistrationService.isRunning();
      tmr.isPaused = TimerRegistrationService.isPaused();
    }, 100);
  };
  const subscription = eventBus.subscribe(
    'timerRegistrationChanged',
    tmr.refreshRunningRegistration,
  );
  $scope.$on('$destroy', function() {
    if (subscription) eventBus.unsubscribe(subscription);
  });
  const handleError = (error, rejectFunc = undefined) => {
    $timeout(() => {
      if (error?.response?.data) {
        flySvc.error(error.response.data);
      } else {
        flySvc.error(error);
      }

      if (typeof rejectFunc === 'function') rejectFunc();
    }, 0);
  };
  tmr.start = () => {
    if (!checkSecurity('RegistrationOwn:c')) {
      return;
    }
    tmr.registration = null;
    tmr.showPopover = false;
    tmr.showModal = true;
  };
  tmr.restart = () => {
    if (!checkSecurity('RegistrationOwn:c')) {
      return;
    }
    if (!tmr.isPaused) return tmr.start();
    TimerRegistrationService.restartTimerRegistration().then(reg => {
      $timeout(() => {
        if (reg) {
          tmr.registration = reg;
        }
        tmr.showModal = false;
      }, 0);
    }, handleError);
  };

  tmr.stop = (pause = false) => {
    TimerRegistrationService.stopTimerRegistration(pause).then(result => {
      $timeout(() => {
        const { registration, discarded } = result;
        tmr.showPopover = false;
        tmr.registration = null;
        if (discarded) {
          flySvc.proposal('msgTaskTimeRegistrationDiscarded');
          return;
        }
        if (!registration) return;

        var duration = $filter('time')(registration.durationMinutes);

        flySvc.action(
          'Registration created', //title
          'msgTaskTimeRegistrationCreated', //content
          function() {
            //action
            regDialogsSvc.editRegistration(registration, {}).then(function(result) {
              flySvc.success('Registration modified');
            });
          },
          'Edit registration', //Action label
          null, //action param
          {
            duration: duration,
            relation: registration.relation.name,
          }, //title param
          'success',
        ); //display method
      }, 0);
    }, handleError);
  };

  tmr.createRegistration = value => {
    if (!checkSecurity('RegistrationOwn:c')) {
      return;
    }
    return new Promise((resolve, reject) => {
      $timeout(() => {
        if (!value) {
          resolve();
          tmr.showModal = false;
          return;
        }
        TimerRegistrationService.createTimerRegistration(value).then(
          reg => {
            $timeout(() => {
              if (reg) {
                tmr.registration = reg;
              }
              resolve();
              tmr.showModal = false;
            }, 0);
          },
          error => {
            handleError(error, reject);
          },
        );
      }, 0);
    });
  };
  tmr.closeModal = () => {
    $timeout(() => {
      tmr.showModal = false;
    }, 0);
  };

  tmr.refreshRunningRegistration();
  if (!RecentRelationsService.get()) recentRelationsSvc.reloadRecentRelations();
};
